/**
 * CROSS-SELL SECTION
 * Maneja el cambio de tabs (filtro por colección) y actualiza el link
 * personalizado cuando está en modo "URL de colección activa".
 */
(function () {
  'use strict';

  class CrossSellSection {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-cross-sell-tab]'));
      this.panels = Array.from(section.querySelectorAll('[data-cross-sell-panel]'));
      this.link = section.querySelector('[data-cross-sell-link]');
      this.linkIsDynamic = this.link && this.link.hasAttribute('data-cross-sell-link-dynamic');
      this.originalLinkHref = this.link ? this.link.getAttribute('href') : null;

      if (this.tabs.length === 0) {
        this._refreshLink();
        return;
      }

      this._bindEvents();
      this._refreshLink();
    }

    _bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this._activateTab(tab));
      });

      const tabList = this.section.querySelector('[role="tablist"]');
      if (tabList) {
        tabList.addEventListener('keydown', (e) => this._handleKeydown(e));
      }
    }

    _activateTab(tab, focus) {
      const index = parseInt(tab.dataset.crossSellTab, 10);

      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const panelIndex = parseInt(panel.dataset.crossSellPanel, 10);
        if (panelIndex === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });

      this._refreshLink();

      if (focus !== false) {
        tab.focus({ preventScroll: true });
      }
    }

    _refreshLink() {
      if (!this.link || !this.linkIsDynamic) return;

      const activeTab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
      if (!activeTab) return;

      const url = activeTab.dataset.collectionUrl;
      if (url && url !== '#') {
        this.link.setAttribute('href', url);
      } else if (this.originalLinkHref) {
        this.link.setAttribute('href', this.originalLinkHref);
      }
    }

    _handleKeydown(e) {
      const currentIndex = this.tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let newIndex = -1;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          e.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          e.preventDefault();
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      if (newIndex >= 0 && this.tabs[newIndex]) {
        this._activateTab(this.tabs[newIndex]);
      }
    }
  }

  function initSections(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-cross-sell-section]').forEach((el) => {
      if (!el._crossSell) {
        el._crossSell = new CrossSellSection(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  // Theme editor: re-init when section reloads
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-cross-sell-section]');
    if (section) {
      section._crossSell = new CrossSellSection(section);
    }
  });

  // Theme editor: activate the block being selected
  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('[data-cross-sell-section]');
    if (!section || !section._crossSell) return;
    const blockId = e.detail.blockId;
    const tab = section.querySelector('[data-cross-sell-tab][data-block-id="' + blockId + '"]');
    if (tab) {
      section._crossSell._activateTab(tab);
    }
  });
})();
